"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
function SelectContentOnContextMenu({ children }) {
    const ref = react_1.useRef(null);
    const onContextMenu = () => {
        if (ref.current) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNode(ref.current);
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    };
    return (react_1.default.createElement("span", { onContextMenu: onContextMenu, ref: ref }, children));
}
exports.default = SelectContentOnContextMenu;
